<h1 mat-dialog-title>{{'function.Login' | translate}}</h1>
<div mat-dialog-content>
    <app-login-control #loginControl [isModal]="true"></app-login-control>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" [disabled]="false" (click)="loginControl.login();" tabindex="-1">Logga in</button>
    <button mat-raised-button (click)="onCancel()" tabindex="2">Avbryt</button>
</div>
